import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Committee from './pages/Committee';
import Faculty from './pages/Faculty';
import Program from './pages/Program';
import Abstract from './pages/Abstract';
import Registration from './pages/Registration';
import Brochure from './pages/Brochure';
import Quiz from './pages/Quiz';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <main style={{ flex: 1, padding: '20px' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/committee" element={<Committee />} />
              <Route path="/faculty" element={<Faculty />} />
              <Route path="/program" element={<Program />} />
              <Route path="/abstract" element={<Abstract />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/brochure" element={<Brochure />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App; 